"use client";

import { c as _c } from "react/compiler-runtime";
import { Text } from "@workspace/ui/components";
import { AccessibilityNew, Close, Contrast, DarkMode, LightMode, RestartAlt, ZoomIn, ZoomOut } from "@workspace/ui/components/Svg";
import React, { useState } from "react";
import styled from "styled-components";

// Context
import { useTheme } from "../../context/ThemeContext";
const Accessible = t0 => {
  const $ = _c(9);
  const {
    hideButton,
    setHideButton
  } = t0;
  const [open, setOpen] = useState(false);
  const {
    state: t1,
    scaleFont,
    toggleTheme,
    setContrast,
    resetTheme
  } = useTheme();
  const {
    isDark
  } = t1;
  let t2;
  if ($[0] !== hideButton || $[1] !== isDark || $[2] !== open || $[3] !== resetTheme || $[4] !== scaleFont || $[5] !== setContrast || $[6] !== setHideButton || $[7] !== toggleTheme) {
    t2 = hideButton ? null : <><Navigation open={open}><NavPosition onClick={() => scaleFont("up")}><ZoomIn /> <Text text={"Zwi\u0119ksz tekst"} /></NavPosition><NavPosition onClick={() => scaleFont("down")}><ZoomOut /> <Text text="Zmniejsz tekst" /></NavPosition><NavPosition onClick={() => toggleTheme()}>{isDark ? <LightMode /> : <DarkMode />}<Text text={isDark ? "Jasny motyw" : "Ciemny motyw"} /></NavPosition><NavPosition onClick={() => setContrast()}><Contrast /><Text text="Kontrast" /></NavPosition><NavPosition onClick={() => resetTheme()}><RestartAlt /><Text text="Zresetuj wszystkie" /></NavPosition></Navigation><AccessibleWrapper open={open} onClick={() => setOpen(!open)}><AccessibilityNew /><HideButton onClick={e => {
          e.stopPropagation();
          localStorage.setItem("carry-hide-button", "true");
          setHideButton(!hideButton);
        }}><Close /></HideButton></AccessibleWrapper></>;
    $[0] = hideButton;
    $[1] = isDark;
    $[2] = open;
    $[3] = resetTheme;
    $[4] = scaleFont;
    $[5] = setContrast;
    $[6] = setHideButton;
    $[7] = toggleTheme;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
const HideButton = styled.div`
  position: absolute;
  top: -6px;
  left: -6px;
  width: 20px;
  height: 20px;
  background-color: ${({
  theme
}) => theme.colors.GRAYSCALE_200};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({
  theme
}) => theme.colors.GRAYSCALE_300};
    transform: scale(1.1);
  }

  svg {
    font-size: 14px !important;
    width: 14px !important;
    height: 14px !important;
    color: ${({
  theme
}) => theme.colors.BLACK};
  }
`;
const NavPosition = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  margin: 10px 0;
  color: ${({
  theme
}) => theme.colors.BLACK};

  svg {
    margin-right: 10px;
  }
`;
const Navigation = styled.div`
  position: fixed;
  font-size: 16px !important;
  line-height: 1.4;
  z-index: 9999;
  top: 100px !important;
  right: ${({
  open
}) => open ? "0" : "-180px"};
  transition: right 750ms cubic-bezier(0.23, 1, 0.32, 1);
  overflow: hidden;

  width: 180px;
  height: auto;
  background-color: ${({
  theme
}) => theme.colors.WHITE};
  box-shadow: ${({
  theme
}) => theme.boxShadows.primary};
  border-radius: 0 0 0 ${({
  theme
}) => theme.radii.default};
  padding: 10px;
`;
const AccessibleWrapper = styled.div`
  box-shadow: 0 0 10px 0 rgb(0 0 0 / 20%);
  background-color: #4054b2;
  width: 52px;
  height: 52px;
  cursor: pointer;

  position: fixed;
  font-size: 16px !important;
  line-height: 1.4;
  z-index: 9999;
  top: 100px !important;
  right: ${({
  open
}) => open ? "180px" : "0"};
  transition: right 750ms cubic-bezier(0.23, 1, 0.32, 1);

  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({
  theme
}) => theme.colors.WHITE};
  border-radius: ${({
  theme
}) => theme.radii.default} 0 0
    ${({
  theme
}) => theme.radii.default};

  svg {
    font-size: 37px;

    width: 42px;
    height: 42px;
  }
`;
export default Accessible;